module.exports = __webpack_public_path__ + "static/media/recruit_480_game.84b71396.png";